import useAuth from '@app/auth/use-auth';
import { useGetPackaging } from '@shared/api';
import Page from '../../components/layout/page/page';
import PackagingTable from './components/packaging-table';

export type PackagingResponseType = {
  packagingTypes: PackagingTypesType[];
  averageEmissionsPerRecipe: number;
  averagePercentageRecycled: number;
  highestEmissionsMaterials: any[];
  totalEmissionsPerItem: any[];
};

export interface PackagingTypesType {
  uuid: string;
  description: string;
  noOfTimesUsed: number;
  emissionsPerProductPackaged: number;
}

export interface TotalEmissionsPerItemType {
  id: string;
  label: string;
  totalEmissionsPerItem: number;
}

const PackagingListPage = () => {
  const data = useGetPackaging();
  const { user } = useAuth();
  const { productCategory } = user!;
  const productClient = productCategory === 'product';

  return (
    <Page name="Packaging" page="subpage">
      <PackagingTable {...data} includeCreateButton={productClient} />
    </Page>
  );
};

export default PackagingListPage;
